export const escapeFontFamilyName = (fontFamily: string) => {
  return fontFamily.replace(/"/g, '\\"').replace(/'/g, "\\'");
};
